import { getTimezoneOffset } from "date-fns-tz";
import moment from "moment-timezone";

import { ISelectOption } from "shared/components/Form/Fields/select/types";
import { TIME_ZONES } from "shared/constants";

export enum TimeFormat {
  twelve = "12-hour",
  twentyFour = "24-hour",
}

export enum DateFormat {
  dmy = "dd/mm/yyyy",
  mdy = "mm/dd/yyyy",
  ymd = "yyyy/mm/dd",
}

export interface ITimezoneSelectOption extends ISelectOption {
  utc: string;
}

export const getRegionalSettingsOptions = () => {
  const defaultTimeZone = moment.tz.guess();

  const timezoneToUtc = (
    timezone: string,
    fullDate?: string | null,
    withPrefix?: boolean
  ) => {
    const dateTime = fullDate ? new Date(fullDate) : undefined;
    const ms = getTimezoneOffset(timezone, dateTime);
    const isNegative = ms < 0;
    const hours = Math.abs(Math.floor((ms / (1000 * 60 * 60)) % 24));
    const minutes = Math.abs(Math.floor((ms / (1000 * 60)) % 60));

    const utc = `${isNegative ? "-" : "+"}${hours < 10 ? "0" : ""}${hours}:${
      minutes < 10 ? "0" : ""
    }${minutes}`;

    return withPrefix ? `UTC${utc}` : utc;
  };

  const timeZone: ITimezoneSelectOption[] = TIME_ZONES.map((zone) => ({
    label: zone,
    value: zone,
    utc: `UTC${timezoneToUtc(zone)}`,
  }));

  const dateFormat: ISelectOption[] = [
    {
      label: "dd/mm/yyyy (eg. 31/12/2000)",
      value: DateFormat.dmy,
    },
    {
      label: "mm/dd/yyyy (eg. 12/31/2000)",
      value: DateFormat.mdy,
    },
    {
      label: "yyyy/mm/dd (eg. 2000/12/31)",
      value: DateFormat.ymd,
    },
  ];

  const timeFormat: ISelectOption[] = [
    {
      label: "12-hour (eg. 5:59 PM)",
      value: TimeFormat.twelve,
    },
    {
      label: "24-hour (eg. 17:59)",
      value: TimeFormat.twentyFour,
    },
  ];

  return { timeZone, dateFormat, timeFormat, timezoneToUtc, defaultTimeZone };
};
